import { render, staticRenderFns } from "./page-head.vue?vue&type=template&id=4edca730&"
import script from "./page-head.vue?vue&type=script&lang=js&"
export * from "./page-head.vue?vue&type=script&lang=js&"
import style0 from "./page-head.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports